import React from "react";
import {FieldProps} from "../List";
import Translation from "../../Utils/Translation";

export default ({value, ...props}: FieldProps) => {
    if (props.config?.fields?.[props.field]?.translate) {
        return <Translation id={value} base={[props.config.componentName + ".field." + props.field, props.config.componentName]} />
    }
    return value;
}